<template>
  <v-container v-if="!review">
    <div class="text-h4">Emergency Failover Destination</div>
    <p>Please enter the phone number to forward all calls in the case of an emergency.</p>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="product.emerg_failover_dest"
          label="Phone Number*"
          required
          v-mask="'(###) ###-####'"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
  <div v-else>
    <ReviewItem
      label="What is Emergency Failover Destination?"
      :value="getProductInfo().emerg_failover_dest"
    />
  </div>
</template>

<script>
/* eslint object-curly-newline: "off", operator-linebreak: "off" */
import { mapGetters, mapActions } from 'vuex';
import ReviewItem from '@/components/ReviewItem.vue';
import _ from 'lodash';

export default {
  name: 'EmergFailoverDest',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  data: () => ({
    product: {
      emerg_failover_dest: '',
    },
  }),
  mounted() {
    const vm = this;
    const productInfo = _.cloneDeep(vm.getProductInfo());
    vm.product.emerg_failover_dest = productInfo.emerg_failover_dest || '';
  },
  methods: {
    ...mapActions(['updateStoreFormData']),
    registerFormChange(newVal) {
      this.updateStoreFormData({
        data: newVal.emerg_failover_dest,
        main: this.getProductIdSelected,
        sub: 'emerg_failover_dest',
      });
    },
  },
  watch: {
    product: {
      handler(val) {
        this.registerFormChange(val);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
  },
  components: {
    ReviewItem,
  },
};
</script>
